import { render } from "./KnowhowTip4.vue?vue&type=template&id=31f984f0"
import script from "./KnowhowTip4.vue?vue&type=script&lang=js"
export * from "./KnowhowTip4.vue?vue&type=script&lang=js"

import "./KnowhowTip4.vue?vue&type=style&index=0&id=31f984f0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__